module.exports = __webpack_public_path__ + "img/cp-ai-3.279efa89.jpg";